import styled from 'styled-components';

export const StyledOfferFinalWrapper = styled.div`
  margin: 20px 0;
`;

export const StyledFinalSummaryRow = styled.div`
  border: none;
`;

export const StyledSigningTotal = styled.span`
  font-size: .875rem;
  float: right;
`;

export const StyledSigningTotalTitle = styled.span`
  font-size: .875rem;
`;



/** WEBPACK FOOTER **
 ** ./src/pages/TrimView/BestOfferList/BestOfferCard/components/OfferSummary/SummaryFinal/styles.js
 **/